import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useGoogleVerification = () => {
  useEffect(() => {
    const fetchAndInjectVerification = async () => {
      try {
        const { data, error } = await supabase
          .from('seo_settings')
          .select('google_search_console_verification')
          .maybeSingle();

        if (error) {
          console.error('Error fetching Google verification code:', error);
          return;
        }

        if (data?.google_search_console_verification) {
          // Check if meta tag already exists
          const existingMeta = document.querySelector('meta[name="google-site-verification"]');
          
          if (existingMeta) {
            // Update existing meta tag
            existingMeta.setAttribute('content', data.google_search_console_verification);
          } else {
            // Create and inject new meta tag
            const meta = document.createElement('meta');
            meta.name = 'google-site-verification';
            meta.content = data.google_search_console_verification;
            document.head.appendChild(meta);
          }
        }
      } catch (error) {
        console.error('Error injecting Google verification meta tag:', error);
      }
    };

    fetchAndInjectVerification();
  }, []);
};
